import React from "react"

import "./thincontainer.css"

const ThinContainer = ({ children }) => {
  return <div className="thin-container">{children}</div>
}

export { ThinContainer }
